import React, { Component } from 'react'
import { ToggleFeature, features } from 'features/ToggleFeature'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import 'react-placeholder/lib/reactPlaceholder.css'
import '@loyal_template/showcases.css'

const RechargePhoneId = 71
const BillPaymentId = 21188
const FuelCreditId = 117
class ServicesContainer extends Component {
  render () {
    let hasRechargePhone = this.props.services.find(
      s => s.supplierId === RechargePhoneId
    )
    let hasBillPayment = this.props.services.find(
      s => s.supplierId === BillPaymentId
    )
    let hasFuelCredit = this.props.services.find(
      s => s.supplierId === FuelCreditId
    )

    return (
      <ToggleFeature
        feature={features.ServicesContainer}
        customValidation={hasRechargePhone || hasBillPayment || hasFuelCredit}
        hasRechargePhone={hasRechargePhone}
        hasBillPayment={hasBillPayment}
        hasFuelCredit={hasFuelCredit}
      />
    )
  }
}

const mapStateToProps = ({ stores: { services } }) => ({ services })

ServicesContainer.propTypes = {
  services: PropTypes.array
}

export default connect(
  mapStateToProps,
  null
)(ServicesContainer)



// WEBPACK FOOTER //
// ./src/features/Services/ServicesContainer.js